import { createAction, props } from "@ngrx/store";

export const setBalance = createAction(
  '[Balance] Set Balance',
  props<{ balance: string }>()
);

export const resetBalance = createAction(
  '[Balance] Reset Balance'
);
